
function initULPredictiveCards(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const moneyFormatter = (currency) => {
      try {
        return new Intl.NumberFormat('pt-BR', {
          style: 'currency',
          currency: currency || 'BRL'
        });
      } catch (error) {
        return new Intl.NumberFormat('pt-BR', {
          style: 'currency',
          currency: 'BRL'
        });
      }
    };

    const parseVariants = (card) => {
      try {
        const source = card.querySelector('[data-product-variants-json]');
        if (!source) return [];
        return JSON.parse(source.textContent || '[]');
      } catch (error) {
        console.warn('[UL Vitrine] Não foi possível ler as variantes do produto.', error);
        return [];
      }
    };

    const selectedOptionsFromCard = (card) => {
      const groups = card.querySelectorAll('[data-option-index]');
      const values = [];

      groups.forEach((group) => {
        const index = Number(group.dataset.optionIndex);
        const selectedButton = group.querySelector('.ul-product-card__option-button.is-selected');
        const select = group.querySelector('[data-option-select]');

        if (selectedButton) values[index] = selectedButton.dataset.optionValue;
        else if (select) values[index] = select.value;
      });

      return values;
    };

    const findVariant = (variants, selectedOptions) => {
      return variants.find((variant) => {
        if (!Array.isArray(variant.options)) return false;

        return variant.options.every((value, index) => {
          return value === selectedOptions[index];
        });
      });
    };

    const resolveSelectedVariant = (card, variants) => {
      if (!Array.isArray(variants) || !variants.length) return null;

      const groups = card.querySelectorAll('[data-option-index]');

      if (groups.length > 0) {
        const selectedOptions = selectedOptionsFromCard(card);
        if (selectedOptions.length) {
          const exact = findVariant(variants, selectedOptions);
          if (exact) return exact;
        }
      }

      const hiddenInput = card.querySelector('[data-variant-id]');
      const hiddenId = hiddenInput ? String(hiddenInput.value || '') : '';

      if (hiddenId) {
        const byHiddenId = variants.find((variant) => String(variant.id) === hiddenId);
        if (byHiddenId) return byHiddenId;
      }

      const initialId = String(card.dataset.initialVariantId || '');

      if (initialId) {
        const byInitialId = variants.find((variant) => String(variant.id) === initialId);
        if (byInitialId) return byInitialId;
      }

      return variants.find((variant) => isVariantPurchasable(variant)) || variants[0] || null;
    };

    const isVariantPurchasable = (variant) => {
      if (!variant) return false;

      return Boolean(
        variant.available === true ||
        variant.inventory_policy === 'continue'
      );
    };

    const isContinueSellingWithoutStock = (variant) => {
      if (!variant) return false;

      return (
        variant.inventory_policy === 'continue' &&
        Number(variant.inventory_quantity || 0) <= 0
      );
    };

    const isLowStockVariant = (card, variant) => {
      if (!card || !variant) return false;
      if (true !== true) return false;
      if (card.dataset.lowStockDisabled === 'true') return false;
      if (variant.inventory_management !== 'shopify') return false;
      if (variant.inventory_policy === 'continue') return false;

      const quantity = Number(variant.inventory_quantity || 0);
      const threshold = Number(10 || 10);

      return quantity > 0 && quantity <= threshold;
    };

    const lowStockMessage = (variant) => {
      const quantity = Number(variant && variant.inventory_quantity || 0);

      if (true !== true) {
        return "Últimas unidades";
      }

      return "Apenas [quantidade] em estoque"
        .replace('[quantidade]', String(quantity));
    };

    const normalizedImageUrl = (src) => {
      if (!src) return '';
      if (src.startsWith('//')) return `${window.location.protocol}${src}`;
      return src;
    };

    // Mantém versões responsivas da imagem ao trocar variante ou produto.
    const setResponsiveProductImage = (image, src, savedSrcset = '', savedSizes = '') => {
      if (!image || !src) return;
      const normalized = normalizedImageUrl(src);
      const sizes = savedSizes || image.getAttribute('sizes') || '(max-width: 749px) 80vw, 340px';
      try {
        const url = new URL(normalized, window.location.origin);
        const requestedWidth = Number(url.searchParams.get('width'));
        const maxWidth = requestedWidth > 0 ? Math.min(1200, requestedWidth) : 1200;
        const widths = [240, 360, 480, 640, 800, 1000, 1200].filter(width => width <= maxWidth);
        if (!widths.includes(maxWidth)) widths.push(maxWidth);
        const imageUrl = width => {
          const candidate = new URL(url.href);
          candidate.searchParams.set('width', String(width));
          return candidate.href;
        };
        image.setAttribute('sizes', sizes);
        image.setAttribute('srcset', savedSrcset || widths.map(width => `${imageUrl(width)} ${width}w`).join(', '));
        image.src = imageUrl(Math.min(640, maxWidth));
      } catch (error) {
        // Não conserva srcset de outro produto se a URL recebida for inválida.
        image.removeAttribute('srcset');
        image.setAttribute('sizes', sizes);
        image.src = normalized;
      }
    };

    const variantImageUrl = (variant) => {
      if (!variant) return '';

      if (variant.featured_image) {
        if (typeof variant.featured_image === 'string') {
          return normalizedImageUrl(variant.featured_image);
        }

        if (variant.featured_image.src) {
          return normalizedImageUrl(variant.featured_image.src);
        }
      }

      if (variant.featured_media && variant.featured_media.preview_image && variant.featured_media.preview_image.src) {
        return normalizedImageUrl(variant.featured_media.preview_image.src);
      }

      return '';
    };

    const updatePrimaryImage = (card, variant) => {
      if (true !== true) return;

      const image = card.querySelector('.ul-product-card__image--primary');
      if (!image) return;

      const src = variantImageUrl(variant);
      if (!src) return;

      setResponsiveProductImage(image, src);

      if ("fade" === 'fade') {
        image.animate(
          [
            { opacity: 0.35 },
            { opacity: 1 }
          ],
          {
            duration: 300,
            easing: 'ease'
          }
        );
      }
    };

    const getUnavailableBehavior = () => {
      return "selectable";
    };

    const updateVariantAvailabilityUI = (card, variants) => {
      const groups = Array.from(card.querySelectorAll('[data-option-index]'));
      const current = selectedOptionsFromCard(card);
      const behavior = getUnavailableBehavior();
      const showUnavailableSuffix = true;
      const unavailableSuffix = "Esgotado";

      groups.forEach((group) => {
        const index = Number(group.dataset.optionIndex);

        group.querySelectorAll('.ul-product-card__option-button').forEach((button) => {
          const candidate = [...current];
          candidate[index] = button.dataset.optionValue;

          const hasAvailableCombination = variants.some((variant) => {
            if (!isVariantPurchasable(variant) || !Array.isArray(variant.options)) return false;

            return variant.options.every((value, optionIndex) => {
              if (candidate[optionIndex] === undefined) return true;
              return value === candidate[optionIndex];
            });
          });

          const unavailable = !hasAvailableCombination;

          button.classList.toggle('is-unavailable', unavailable);
          button.disabled = unavailable && behavior === 'disabled';
          button.setAttribute('aria-disabled', unavailable ? 'true' : 'false');

          const label = button.querySelector('.ul-product-card__option-label');
          const original = button.dataset.originalLabel || button.dataset.optionValue || '';

          if (label) {
            label.textContent = original;
          }

          button.title = unavailable && showUnavailableSuffix && unavailableSuffix
            ? `${original} — ${unavailableSuffix}`
            : original;
        });

        group.querySelectorAll('[data-option-select] option').forEach((option) => {
          const candidate = [...current];
          candidate[index] = option.value;

          const hasAvailableCombination = variants.some((variant) => {
            if (!isVariantPurchasable(variant) || !Array.isArray(variant.options)) return false;

            return variant.options.every((value, optionIndex) => {
              if (candidate[optionIndex] === undefined) return true;
              return value === candidate[optionIndex];
            });
          });

          const unavailable = !hasAvailableCombination;
          const original = option.dataset.originalLabel || option.value;

          option.textContent = unavailable && showUnavailableSuffix && unavailableSuffix
            ? `${original} — ${unavailableSuffix}`
            : original;

          option.disabled = unavailable && behavior === 'disabled';
        });
      });
    };

    const updateVariantFeedback = (card, variant, exists = true) => {
      const feedback = card.querySelector('[data-variant-feedback]');
      const stock = card.querySelector('[data-stock-text]');
      const addButton = card.querySelector('[data-add-button]');

      if (!exists) {
        if (feedback) {
          feedback.textContent = "Combinação indisponível";
          feedback.classList.remove('is-available', 'is-low-stock');
          feedback.classList.add('is-unavailable');
        }

        if (stock && true === true) {
          stock.textContent = "Combinação indisponível";
          stock.classList.remove('is-low-stock');
          stock.style.color = 'var(--ups-danger)';
        }

        if (addButton) {
          addButton.disabled = true;
          addButton.textContent = 'Indisponível';
        }

        return;
      }

      const available = isVariantPurchasable(variant);
      const continueSelling = isContinueSellingWithoutStock(variant);
      const lowStock = isLowStockVariant(card, variant);

      if (feedback) {
        feedback.textContent = available
          ? (
              continueSelling
                ? "Disponível para compra"
                : (
                    lowStock
                      ? lowStockMessage(variant)
                      : ""
                  )
            )
          : "Esgotado";

        feedback.classList.toggle('is-available', available);
        feedback.classList.toggle('is-unavailable', !available);
        feedback.classList.toggle('is-low-stock', lowStock);
      }
    };

    const updateCardVariant = (card) => {
      const variants = parseVariants(card);
      if (!variants.length) return;

      const hasOptionGroups = card.querySelectorAll('[data-option-index]').length > 0;
      const selectedOptions = selectedOptionsFromCard(card);

      let variant = null;

      if (hasOptionGroups && selectedOptions.length) {
        variant = findVariant(variants, selectedOptions);
      } else {
        variant = resolveSelectedVariant(card, variants);
      }

      if (!variant) {
        updateVariantFeedback(card, null, false);
        updateVariantAvailabilityUI(card, variants);
        return;
      }

      const hiddenInput = card.querySelector('[data-variant-id]');
      const button = card.querySelector('[data-add-button]');
      const price = card.querySelector('[data-price]');
      const comparePrice = card.querySelector('[data-compare-price]');
      const discountBadge = card.querySelector('[data-discount-badge]');
      const stock = card.querySelector('[data-stock-text]');
      const formatter = moneyFormatter(card.dataset.currency);

      if (hiddenInput) hiddenInput.value = variant.id;

      if (price) {
        price.textContent = formatter.format((variant.price || 0) / 100);
      }

      if (comparePrice) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          comparePrice.textContent = formatter.format(variant.compare_at_price / 100);
          comparePrice.classList.remove('is-hidden');
        } else {
          comparePrice.textContent = '';
          comparePrice.classList.add('is-hidden');
        }
      }

      if (discountBadge) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          const discount = Math.round(
            ((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100
          );
          discountBadge.textContent = `-${discount}%`;
          discountBadge.style.display = '';
        } else if (card.dataset.manualDiscount) {
          discountBadge.textContent = card.dataset.manualDiscount;
          discountBadge.style.display = '';
        } else if (true === true || card.dataset.linkedMode === 'linked') {
          discountBadge.style.display = 'none';
        }
      }

      updatePrimaryImage(card, variant);

      const purchasable = isVariantPurchasable(variant);
      const continueSelling = isContinueSellingWithoutStock(variant);
      const lowStock = isLowStockVariant(card, variant);

      if (button) {
        const defaultLabel = button.dataset.defaultLabel || "Comprar agora";
        button.disabled = !purchasable;
        button.textContent = purchasable ? defaultLabel : 'Esgotado';
      }

      if (stock && true === true) {
        stock.textContent = purchasable
          ? (
              continueSelling
                ? "Disponível para compra"
                : (
                    lowStock
                      ? lowStockMessage(variant)
                      : ""
                  )
            )
          : "Esgotado";

        stock.classList.toggle('is-low-stock', lowStock);
        stock.style.color = lowStock
          ? "#d92606"
          : (
              purchasable
                ? 'var(--ups-success)'
                : 'var(--ups-danger)'
            );
      }

      updateVariantFeedback(card, variant, true);
      updateVariantAvailabilityUI(card, variants);

      if (true === true) {
        card.querySelectorAll('a[href]').forEach((link) => {
          try {
            const url = new URL(link.href, window.location.origin);
            if (url.pathname === new URL(card.dataset.productUrl, window.location.origin).pathname) {
              url.searchParams.set('variant', variant.id);
              link.href = url.toString();
            }
          } catch (error) {}
        });
      }
    };

    const initCard = (card) => {
      if (card.dataset.productCardInitialized === 'true') return;
      card.dataset.productCardInitialized = 'true';

      card.querySelectorAll('.ul-product-card__option-button').forEach((button) => {
        button.addEventListener('click', () => {
          if (button.disabled && getUnavailableBehavior() === 'disabled') return;

          const group = button.closest('[data-option-index]');
          if (!group) return;

          group.querySelectorAll('.ul-product-card__option-button').forEach((item) => {
            item.classList.remove('is-selected');
            item.setAttribute('aria-pressed', 'false');
          });

          button.classList.add('is-selected');
          button.setAttribute('aria-pressed', 'true');

          updateCardVariant(card);
        });
      });

      card.querySelectorAll('[data-option-select]').forEach((select) => {
        select.addEventListener('change', () => updateCardVariant(card));
      });

      updateCardVariant(card);

    };

    const initializeCards = () => {
    root.querySelectorAll('[data-product-card]').forEach(initCard);

    /* No celular, um toque alterna entre a imagem principal e a segunda imagem. */
    root.querySelectorAll('.ul-product-card__image-wrap').forEach((imageWrap) => {
      const imageLink = imageWrap.closest('.ul-product-card__image-link');
      const card = imageWrap.closest('.ul-product-card');
      const dots = card ? card.querySelectorAll('.ul-product-card__media-dots span') : [];

      if (!imageLink || imageWrap.dataset.ulImageInitialized === 'true') return;
      imageWrap.dataset.ulImageInitialized = 'true';

      imageLink.addEventListener('click', (event) => {
        if (!window.matchMedia('(hover: none), (pointer: coarse)').matches) return;
        if (!imageWrap.classList.contains('has-hover-image')) return;
        if (card?.querySelector('.ul-product-card__image--hover')?.style.display === 'none') return;

        if (imageWrap.classList.contains('is-showing-secondary')) return;
        event.preventDefault();

        const showingSecondary = imageWrap.classList.toggle('is-showing-secondary');

        if (dots.length > 0) {
          dots.forEach((dot, index) => {
            dot.classList.toggle('is-active', showingSecondary ? index === 1 : index === 0);
          });
        }
      });
    });


    };
    initializeCards();

    root.addEventListener('click', async (event) => {
      const button = event.target.closest('[data-add-button]');
      if (!button || !root.contains(button) || button.disabled) return;
      const card = button.closest('[data-product-card]');
      const variantInput = card?.querySelector('[data-variant-id]');
      if (!variantInput?.value) return;
      event.preventDefault();
      event.stopPropagation();
      if (card.dataset.purchasePending === 'true') return;
      card.dataset.purchasePending = 'true';
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      let feedback = card.querySelector('[data-purchase-feedback]');
      if (!feedback) {
        feedback = document.createElement('p');
        feedback.dataset.purchaseFeedback = '';
        feedback.setAttribute('role', 'status');
        feedback.setAttribute('aria-live', 'polite');
        button.parentElement.appendChild(feedback);
      }
      feedback.textContent = '';
      try {
        // Close the theme's search overlay before Snap opens its drawer.
        const modal = document.querySelector('#search-modal.active');
        modal?.querySelector('.search__close')?.click();
        const shopRoot = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${shopRoot}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantInput.value, quantity: 1 }] })
        });
        const result = await response.json();
        if (!response.ok || result.status >= 400) {
          throw new Error(result.description || result.message || 'Não foi possível adicionar o produto. Tente novamente.');
        }
        // Public API exposed by the installed Snap Cart Drawer app.
        if (typeof window.snapCart?.open === 'function') {
          window.snapCart.open();
        } else if (typeof window.openSnapCart === 'function') {
          window.openSnapCart();
        } else {
          // Snap also observes cart/add.js and listens to this opening event.
          document.dispatchEvent(new CustomEvent('opencart'));
        }
        feedback.textContent = 'Produto adicionado ao carrinho.';
      } catch (error) {
        feedback.textContent = error.message || 'Não foi possível adicionar o produto. Tente novamente.';
        // Bring the message back into view when a failed purchase closed search.
        if (!document.querySelector('#search-modal.active')) {
          document.querySelector('.search-modal-trigger')?.click();
        }
      } finally {
        delete card.dataset.purchasePending;
        button.removeAttribute('aria-busy');
        const variant = parseVariants(card).find(item => String(item.id) === String(variantInput.value));
        button.disabled = variant ? !isVariantPurchasable(variant) : false;
      }
    });
}

class PredictiveSearch extends SearchForm {
	constructor() {
		super();
		this.cachedResults = {};
		this.predictiveSearchResults = this.querySelector(
			"[data-predictive-search]",
		);
		this.allPredictiveSearchInstances =
			document.querySelectorAll("predictive-search");
		this.isOpen = false;
		this.abortController = new AbortController();
		this.searchTerm = "";
		this.body = document.querySelector("body");
		this.headerBottom = document.querySelector(".header__bottom");
		this.promoModal = document.querySelector(".search__modal");
		this.headerInput = document.querySelector(".search-modal .search__input");
		this.calcHeight();
		this.setupEventListeners();

		const searchResizeObserver = new ResizeObserver((entries) => {
			const [entry] = entries;

			if (entry.contentRect.width < 991) {
				this.calcHeight(65);
			} else {
				this.calcHeight(0);
			}
		});

		searchResizeObserver.observe(this.body);
	}

	calcHeight(buttonHeight) {
		let heightAnnouncementBar = document.querySelector(".section-announcement")
			? document.querySelector(".section-announcement").getBoundingClientRect()
					.height
			: 0;
		let heightHeader = document.querySelector(".shopify-section-header")
			? document
					.querySelector(".shopify-section-header")
					.getBoundingClientRect().height
			: 0;
		let heightSearchTop = document.querySelector(".search__form__wrapper")
			? document.querySelector(".search__form__wrapper").getBoundingClientRect()
					.height
			: 0;
		let heightInput = this.headerInput.getBoundingClientRect().height;

		if (document.querySelector(".predictive-search")) {
			let maxHeightContent = parseFloat(
				window
					.getComputedStyle(document.querySelector(".predictive-search"), null)
					.getPropertyValue("max-height"),
			);
			let heightContent = document
				.querySelector(".predictive-search")
				.getBoundingClientRect().height;

			let clientHeight = document.documentElement.clientHeight;
			let maxHeightAllowed =
				clientHeight -
				//heightAnnouncementBar -
				//heightHeader -
				heightSearchTop -
				heightInput -
				buttonHeight -
				10;
			document.querySelector(
				".predictive-search",
			).style.maxHeight = `${maxHeightAllowed}px`;
		}
	}

	setupEventListeners() {
		this.input.form.addEventListener("submit", this.onFormSubmit.bind(this));
		this.input.addEventListener("focus", this.onFocus.bind(this));
		this.addEventListener("focusout", this.onFocusOut.bind(this));
		this.addEventListener("keyup", this.onKeyup.bind(this));
		this.addEventListener("keydown", this.onKeydown.bind(this));
	}

	getQuery() {
		return this.input.value.trim();
	}

	onChange() {
		const newSearchTerm = this.getQuery();
		if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
			// Remove the results when they are no longer relevant for the new search term
			// so they don't show up when the dropdown opens again
			this.querySelector("#predictive-search-results-groups-wrapper")?.remove();
		}

		// Update the term asap, don't wait for the predictive search query to finish loading
		this.updateSearchForTerm(this.searchTerm, newSearchTerm);

		this.searchTerm = newSearchTerm;

		if (!this.searchTerm.length) {
			this.close(true);
			return;
		}

		this.getSearchResults(this.searchTerm);
	}

	onFormSubmit(event) {
		if (
			!this.getQuery().length ||
			this.querySelector('[aria-selected="true"] a') ||
			event.submitter?.classList.contains("card__link")
		)
			event.preventDefault();
	}

	onFormReset(event) {
		super.onFormReset(event);
		if (super.shouldResetForm()) {
			this.searchTerm = "";
			this.abortController.abort();
			this.abortController = new AbortController();
			this.closeResults(true);
		}
	}

	onFocus() {
		const currentSearchTerm = this.getQuery();
		if (this.classList.contains("search-modal__form")) {
			if (this.headerBottom) {
				this.headerBottom.classList.add("header__bottom--visible");
			}
			if (this.promoModal) {
				this.promoModal.classList.remove("search__modal--hidden");
			}
		}

		if (!currentSearchTerm.length) {
			return;
		}

		if (this.searchTerm !== currentSearchTerm) {
			// Search term was changed from other search input, treat it as a user change
			this.onChange();
		} else if (this.getAttribute("results") === "true") {
			this.open();
			if (this.promoModal) {
				this.promoModal.classList.add("search__modal--hidden");
			}
		} else {
			this.getSearchResults(this.searchTerm);
		}
	}

	onFocusOut() {
		if (this.classList.contains("search-modal__form")) {
			if (this.headerBottom) {
				this.headerBottom.classList.remove("header__bottom--visible");
			}
		}
		if (!this.classList.contains("search-modal__form")) {
			setTimeout(() => {
				if (!this.contains(document.activeElement)) this.close();
			});
		}
	}

	onBlur() {
		this.headerInput.blur();
	}

	onKeyup(event) {
		if (event.target.closest('.ul-product-card')) return;
		if (!this.getQuery().length) this.close(true);
		event.preventDefault();

		switch (event.code) {
			case "Enter":
				event.preventDefault();
				this.selectOption();
				break;
			case "Escape":
				this.closeResults(true);
				if (this.promoModal && this.classList.contains("search-modal__form")) {
					this.promoModal.classList.add("search__modal--hidden");
				}
				break;
		}

		if (this.getQuery().length) {
			this.hidePromoBlock();
		} else {
			this.showPromoBlock();
		}
	}

	onKeydown(event) {
		if (event.target.closest('.ul-product-card')) return;
		// Prevent the cursor from moving in the input when using the up and down arrow keys
		if (event.code === "ArrowUp" || event.code === "ArrowDown") {
			event.preventDefault();
		}
	}

	updateSearchForTerm(previousTerm, newTerm) {
		const searchForTextElement = this.querySelector(
			"[data-predictive-search-search-for-text]",
		);
		const currentButtonText = searchForTextElement?.innerText;
		if (currentButtonText) {
			if (
				currentButtonText.matchAll(new RegExp(previousTerm, "g")).length > 1
			) {
				// The new term matches part of the button text and not just the search term, do not replace to avoid mistakes
				return;
			}
			const newButtonText = currentButtonText.replace(previousTerm, newTerm);
			searchForTextElement.innerText = newButtonText;
		}
		if (this.getQuery().length) {
			this.hidePromoBlock();
		} else {
			this.showPromoBlock();
		}
	}

	selectOption() {
		const selectedOption = this.querySelector(
			'[aria-selected="true"] a, button[aria-selected="true"]',
		);

		if (selectedOption) selectedOption.click();
	}

	getSearchResults(searchTerm) {
		const queryKey = searchTerm.replace(" ", "-").toLowerCase();
		this.setLiveRegionLoadingState();

		if (this.cachedResults[queryKey]) {
			this.renderSearchResults(this.cachedResults[queryKey]);
			this.clickSearchTabs();
			this.calcHeight();
			return;
		}

		if (this.promoModal && this.classList.contains("search-modal__form")) {
			this.promoModal.classList.add("search__modal--hidden");
		}

		fetch(
			`${routes.predictive_search_url}?q=${encodeURIComponent(
				searchTerm
			)}&section_id=predictive-search`,
			{ signal: this.abortController.signal }
		)
			.then((response) => {
				if (!response.ok) {
					var error = new Error(response.status);
					this.close();
					throw error;
				}
				return response.text();
			})
			.then((text) => {
				const resultsMarkup = new DOMParser()
					.parseFromString(text, "text/html")
					.querySelector("#shopify-section-predictive-search").innerHTML;
				// Save bandwidth keeping the cache in all instances synced
				this.allPredictiveSearchInstances.forEach(
					(predictiveSearchInstance) => {
						predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
					},
				);
				this.renderSearchResults(resultsMarkup);
				this.clickSearchTabs();
				this.calcHeight();
				colorSwatches();
			})
			.catch((error) => {
				if (error?.code === 20) {
					// Code 20 means the call was aborted
					return;
				}
				this.close();
				throw error;
			});
	}

	setLiveRegionLoadingState() {
		this.statusElement =
			this.statusElement || this.querySelector(".predictive-search-status");
		this.loadingText =
			this.loadingText || this.getAttribute("data-loading-text");

		this.setLiveRegionText(this.loadingText);
		this.setAttribute("loading", true);
	}

	setLiveRegionText(statusText) {
		this.statusElement.setAttribute("aria-hidden", "false");
		this.statusElement.textContent = statusText;

		setTimeout(() => {
			this.statusElement.setAttribute("aria-hidden", "true");
		}, 1000);
	}

	renderSearchResults(resultsMarkup) {
		this.predictiveSearchResults.innerHTML = resultsMarkup;
		initULPredictiveCards(this.predictiveSearchResults.querySelector('.ul-predictive-cards'));
		this.setAttribute("results", true);

		this.setLiveRegionResults();
		this.open();
		if (this.promoModal && this.classList.contains("search-modal__form")) {
			this.promoModal.classList.add("search__modal--hidden");
		}
	}

	clickSearchTabs() {
		const results = this.querySelectorAll(".predictive-search__results-list");
		if (results.length != 0) {
			results[0].classList.add("active");
			this.querySelector(".predictive-search__result-tab").classList.add(
				"active",
			);
			this.querySelectorAll(".predictive-search__result-tab").forEach((tab) => {
				tab.addEventListener("click", (event) => {
					event.preventDefault();
					const typeTarget = tab.dataset.typeTarget;
					this.querySelectorAll(".predictive-search__result-tab").forEach(
						(element) => {
							element.classList.remove("active");
						},
					);
					tab.classList.add("active");

					results.forEach((element) => {
						let resultsType = element.dataset.type;
						if (resultsType == typeTarget) {
							element.classList.add("active");
						} else {
							element.classList.remove("active");
						}
					});
				});
			});
		}
	}

	hidePromoBlock() {
		document.querySelector(".search__recomendation")
			? document.querySelector(".search__recomendation").classList.add("hidden")
			: false;
		document.querySelector(".search__line")
			? document.querySelector(".search__line").classList.add("hide")
			: false;
	}

	showPromoBlock() {
		document.querySelector(".search__recomendation")
			? document.querySelector(".search__recomendation").classList.remove("hidden")
			: false;
		document.querySelector(".search__line")
			? document.querySelector(".search__line").classList.remove("hide")
			: false;
	}

	setLiveRegionResults() {
		this.removeAttribute("loading");
		this.setLiveRegionText(
			this.querySelector("[data-predictive-search-live-region-count-value]")
				.textContent,
		);
	}

	open() {
		this.setAttribute("open", true);
		this.input.setAttribute("aria-expanded", true);
		this.isOpen = true;
		this.parentElement.parentElement.parentElement.classList.add('predictive-open');
		if (this.promoModal && this.classList.contains("search-modal__form")) {
			this.promoModal.classList.remove("search__modal--hidden");
		}
	}

	close(clearSearchTerm = false) {
		this.closeResults(clearSearchTerm);
		this.parentElement.parentElement.parentElement.classList.remove('predictive-open');
		this.isOpen = false;
	}

	closeResults(clearSearchTerm = false) {
		if (clearSearchTerm) {
			this.input.value = "";
			this.removeAttribute("results");
		}
		const selected = this.querySelector('[aria-selected="true"]');

		if (selected) selected.setAttribute("aria-selected", false);

		this.input.setAttribute("aria-activedescendant", "");
		this.removeAttribute("loading");
		this.removeAttribute("open");
		this.input.setAttribute("aria-expanded", false);
		this.predictiveSearchResults.removeAttribute("style");
		if (this.promoModal) {
			this.promoModal.classList.add("search__modal--hidden");
		}
	}
}

customElements.define("predictive-search", PredictiveSearch);